import { render, staticRenderFns } from "./bulma_iframe.vue?vue&type=template&id=73e4782d&lang=html"
import script from "./bulma_iframe.vue?vue&type=script&lang=js"
export * from "./bulma_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports